/**
 * Log client-side errors to the server
 */
import { Logger as clientLogger } from 'beaver-logger'
import { serverData } from './server-data'

let logger
function init() {
  logger = clientLogger({
    url: serverData.requestURI + '/log',
    prefix: '',
  })
}

export function initClientErrorLogger() {
  init()
  window.addEventListener('error', createUncaughtErrorHandler as any)
  window.addEventListener('unhandledrejection', handlePromiseRejection)
}

export function logToServer(desc, payload, level = 'error') {
  logger[level](desc, payload)
}

const MAX_ERRORS = 2
let errorsCount = 0

function createUncaughtErrorHandler(desc = 'Uncaught Error') {
  return (message, file, line, column, err) => {
    errorsCount++
    if (errorsCount > MAX_ERRORS) {
      return
    }

    logToServer(desc, {
      message,
      stack: err ? err.stack : '',
      file,
      line,
      column,
      href: window.location.href,
      userAgent: navigator.userAgent,
    })
  }
}

function handlePromiseRejection(promiseRejectionEvent) {
  promiseRejectionEvent.preventDefault()
  const { reason: { message = undefined, stack = undefined } = {} } = promiseRejectionEvent
  if (message && stack) {
    createUncaughtErrorHandler('Unhandled Promise Rejection')(message, '', 0, 0, { stack })
  }
}
